import { render, staticRenderFns } from "./Write.vue?vue&type=template&id=ef7d415c&scoped=true&"
import script from "./Write.vue?vue&type=script&lang=js&"
export * from "./Write.vue?vue&type=script&lang=js&"
import style0 from "./Write.vue?vue&type=style&index=0&id=ef7d415c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7d415c",
  null
  
)

export default component.exports